
import MoveService from "../../services/Move";
import { Move } from "../../types";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

import { QUERY_KEY } from "./useListMoves";

export const makeQueryKey = (id?: Move["id"]) => [QUERY_KEY, id];

function useFetchMove(id?: Move["id"], { enabled = true } = {}) {
  const key = makeQueryKey(id);

  return useAuthorizedQuery(
    key,
    () => {
      if (id) {
        return MoveService.fetchMove(id);
      }

      throw new Error("move id is required");
    },
    { enabled: !!id && enabled }
  );
}

export default useFetchMove;
